import React, { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";

const OptionDrop = ({ array, value, change, heading }) => {
  function handleChange(e) {
    change(e);
  }

  return (
    <div className="w-full mb-2">
      <p className="text-xs 2xl:text-sm text-gray-700 font-medium">{heading}</p>
      {array && (
        <Listbox value={value} onChange={handleChange}>
          {({ open }) => (
            <>
              <div className="relative mt-1">
                <Listbox.Button className="relative w-full py-1.5 md:py-2 pl-3 text-left bg-white rounded-md border border-gray-700 shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-blue-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 text-xs md:text-sm">
                  <span className="block truncate">{value.fileName}</span>
                  <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon
                      className="w-4 h-4 md:w-5 md:h-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>
                <Transition
                  show={open}
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options
                    static
                    className="absolute w-full py-1 mt-1 overflow-auto bg-white rounded-md shadow-2xl max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none text-xs md:text-sm z-10 border-l border-r border-b border-gray-600"
                  >
                    {array.map((item, index) => {
                      if (item.fileType !== "pdf") return null;

                      return (
                        <Listbox.Option
                          key={index}
                          className={({ active }) =>
                            `${
                              active
                                ? "text-blue-900 bg-blue-100"
                                : "text-gray-900"
                            } cursor-default select-none relative py-2 pl-10 pr-4 hover:bg-blue-100`
                          }
                          value={item}
                        >
                          {({ selected, active }) => (
                            <>
                              <span
                                className={`${
                                  selected ? "font-medium" : "font-normal"
                                } block truncate`}
                              >
                                {item.fileName}
                              </span>
                              {selected ? (
                                <span
                                  className={`${
                                    active ? "text-blue-600" : "text-blue-600"
                                  } absolute inset-y-0 left-0 flex items-center pl-3`}
                                >
                                  <CheckIcon
                                    className="w-5 h-5"
                                    aria-hidden="true"
                                  />
                                </span>
                              ) : null}
                            </>
                          )}
                        </Listbox.Option>
                      );
                    })}
                    {/* {array.map((item, index) => (
                      <Listbox.Option
                        key={index}
                        className={({ active }) =>
                          `${
                            active
                              ? "text-blue-900 bg-blue-100"
                              : "text-gray-900"
                          }
      cursor-default select-none relative py-2 pl-10 pr-4 hover:bg-blue-100`
                        }
                        value={item}
                      >
                        {({ selected, active }) => (
                          <>
                            <span
                              className={`${
                                selected ? "font-medium" : "font-normal"
                              } block truncate`}
                            >
                              {item.fileName}
                            </span>
                            {selected ? (
                              <span
                                className={`${
                                  active ? "text-blue-600" : "text-blue-600"
                                }
            absolute inset-y-0 left-0 flex items-center pl-3`}
                              >
                                <CheckIcon
                                  className="w-5 h-5"
                                  aria-hidden="true"
                                />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))} */}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      )}
    </div>
  );
};

export default OptionDrop;
